import { brand } from '../brandAssets';

type BrandLogoProps = {
  variant: 'wordmark' | 'combo' | 'icon' | 'shmatchBrand';
  className?: string;
  /** Alt text for accessibility */
  alt?: string;
};

export function BrandLogo({
  variant,
  className = '',
  alt = 'Shmatch',
}: BrandLogoProps) {
  const src = brand[variant];
  return <img src={src} alt={alt} className={className} decoding="async" />;
}
